export const TABLE_NAMES = [
    "shot_records",
    "machine_status",
    "machine_events",
    "collection_gaps",
    "collector_heartbeat",
];
export const nodeId = {
    machine: (factoryId, machineId) => `machine:${factoryId}:${machineId}`,
    collector: (factoryId) => `collector:${factoryId}`,
    outbox: (factoryId) => `outbox:${factoryId}`,
    uploader: (factoryId) => `uploader:${factoryId}`,
    table: (name) => `table:${name}`,
    legacy: (factoryId) => `legacy:${factoryId}`,
    output: (name) => `output:${name}`,
};
export const OUTPUT_DASHBOARD = nodeId.output("dashboard");
export const OUTPUT_MONITOR = nodeId.output("monitor");
export function edgeId(source, target) {
    return `edge:${source}->${target}`;
}
/** "machine:vietnam:M01" → { factoryId, machineId } / 아니면 null */
export function parseMachineNodeId(id) {
    const m = /^machine:(vietnam|dongtan):(M\d{2})$/.exec(id);
    if (!m)
        return null;
    return { factoryId: m[1], machineId: m[2] };
}
/** id 의 접두어("machine" | "collector" | ...) */
export function nodeKind(id) {
    return id.split(":")[0] ?? "";
}
